import { Check } from 'lucide-react'
import { formatLandingWord } from '@/content/landing'
import { useLandingCopy } from '@/hooks/useGuestLocale'

interface LandingDemoSavedNudgeProps {
  words: string[]
}

/** Lightweight confirmation after the visitor taps two demo words — no extra card chrome. */
export function LandingDemoSavedNudge({ words }: LandingDemoSavedNudgeProps) {
  const copy = useLandingCopy()
  const word = words[words.length - 1] ?? 'nervous'

  return (
    <p
      className="mt-6 flex items-center justify-center gap-2 rounded-full border border-emerald-500/20 bg-emerald-500/[0.06] px-4 py-2.5 text-center text-sm text-foreground/90 sm:text-base"
      data-testid="landing-magic-moment"
    >
      <Check className="h-4 w-4 shrink-0 text-primary" aria-hidden />
      <span data-testid="landing-saved-nudge">{formatLandingWord(copy.savedNudge, word)}</span>
    </p>
  )
}
